import { render } from "./user-page.vue?vue&type=template&id=2ce4a050"
import script from "./user-page.vue?vue&type=script&lang=js"
export * from "./user-page.vue?vue&type=script&lang=js"
script.render = render

export default script